import { Box, Card, Chip, Typography } from "@mui/material"

export default function CardBadgeDeltaChart(props) {
    const { caption, metric, badgeDelta, target } = props

    return (
        <Card
            key={caption}
            sx={{
                p: 2.5,
                height: '100%',
                position: "relative",
                overflow: "hidden",
                borderRadius: 2,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h4">
                    {caption}
                </Typography>

                <Chip
                    size="medium"
                    variant="outlined"
                    label={`${badgeDelta}%`}
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'end', gap: 1 }}>
                <Typography variant="h2">
                    {metric}
                </Typography>
                <Typography variant="h6" color="textSecondary">
                    de {target}
                </Typography>
            </Box>
        </Card>
    )
}